import { store } from '../App/store';

export const mapDispatch =
  <T, K>(fn: (payload: T) => K) =>
  (payload: T) => {
    const parsedPayload = fn(payload);
    store.dispatch(parsedPayload as any);
    return parsedPayload;
  };

export const mapDispatchSet = <T extends object>(set: T) =>
  Object.fromEntries(
    Object.keys(set).map((key) => [key, mapDispatch((set as any)[key])])
  ) as any as T;

export const areStringArraysEqual = (a: string[], b: string[]) =>
  a.length === b.length ? a.join() === b.join() : false;
